var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.qty > 0),expression:"qty > 0"}],staticClass:"fixed overlay pointer-events-none",class:{'opacity-0': !_vm.blur},style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }